import React, { useEffect, useState } from 'react'
import { CaretDown } from '@phosphor-icons/react'

import './style.css'
import FontImg1 from '../../assets/sprite.1-S3RIP6YW.svg'
import FontImg2 from '../../assets/sprite.2-X3NGXFGS.svg'
import FontImg3 from '../../assets/sprite.3-VC45OUQY.svg'
import FontImg4 from '../../assets/sprite.4-OEOCEA52.svg'
import FontImg5 from '../../assets/sprite.5-ICQQXF44.svg'
import FontImg6 from '../../assets/sprite.6-LLF3YW6L.svg'
import FontImg7 from '../../assets/sprite.7-NYA3ED3L.svg'
import FontImg8 from '../../assets/sprite.8-MCM2H3D4.svg'
import FontImg9 from '../../assets/sprite.9-KQM2J2WJ.svg'
import { allFonts } from '../../utils/allFonts'

export default function FontPick({value, setValue}) {
    const [search, setSearch] = useState("")
    const [open, setOpen] = useState(false)

    useEffect(()=>{
        if(open){
            document.getElementById(value?.split(",")[0]?.slice(1, -1)).scrollIntoView()
        }
        if(search !== value?.split(",")[0]?.slice(1, -1)){
            setSearch(value.split(",")[0]?.slice(1, -1))
        }
    },[open, search, value])

    const selectFont = (font) =>{
        setValue(`"${font?.name}",${font?.category}`)
        // const linkId = `font-link-${font.sane}`;
        // if (document.getElementById(linkId)) return;
        // const link = document.createElement("link");
        // link.id = linkId;
        // link.rel = "stylesheet";
        // link.href = `https://fonts.googleapis.com/css2?family=${font.name.replace(/\s+/g,"+")}:ital,wght@${font.variants.sort().join(";")}`;
        // document.head.appendChild(link);
    }

    const onSearch = (val) => {
        setSearch(val)
        const result = allFonts?.filter(item =>
            item?.name?.toLowerCase().includes(val.toLowerCase())
        );
        if(result?.length > 0){
            document.getElementById(result[0]?.name).scrollIntoView()
        }
    }
    
    return (
        <div tabIndex={0} onBlur={(e) => {
            if (e.currentTarget.contains(e.relatedTarget)) {
                return
            }
            setOpen(false)
        }}>
            <div className='FontPick' onClick={() => setOpen(!open)}>
                {open?
                <input onClick={(e)=>e?.stopPropagation()} onKeyDown={(e)=>e?.stopPropagation()} value={search || ""} onChange={(e)=>onSearch(e?.target?.value)}/>
                :
                <p>{value?.split(",")[0]?.slice(1, -1)}</p>
                }
                <CaretDown className={open? 'Select_Arrow Select_Arrow_Open' : 'Select_Arrow'} weight='bold' />
                <div className={open ? 'FontPick_Con FontPick_Con_Open' : 'FontPick_Con'}>
                    <div className='FontPick_Con1'>
                        <img alt='' src={FontImg1}/>
                        <img alt='' src={FontImg2}/>
                        <img alt='' src={FontImg3}/>
                        <img alt='' src={FontImg4}/>
                        <img alt='' src={FontImg5}/>
                        <img alt='' src={FontImg6}/>
                        <img alt='' src={FontImg7}/>
                        <img alt='' src={FontImg8}/>
                        <img alt='' src={FontImg9}/>
                        <div className='FontPick_Overlay1'/>
                        <div className='FontPick_Overlay'>
                            {allFonts?.map((item, index)=>{
                                if(index % 2 === 0){
                                    return(
                                        <div key={index} id={item?.name} onClick={()=>selectFont(item)} className={value?.split(",")[0]?.slice(1, -1) === item?.name? 'FontPick_Section FontPick_Section_Select' : 'FontPick_Section'}/>
                                    )
                                }
                                return(
                                    <div key={index} id={item?.name} onClick={()=>selectFont(item)} className={value?.split(",")[0]?.slice(1, -1) === item?.name? 'FontPick_Section FontPick_Section_Select' : 'FontPick_Section1'}/>
                                )
                            })}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
